import { z } from 'zod';
import { SortOrderSchema, SortOrder } from '@duke-hq/lib/pagination';

export const unitsOfCompetencyTableFiltersSchema = z.object({
  search: z.string().catch(''),
  sort: SortOrderSchema.default(SortOrder.ASC),
  orderBy: z.enum(['code', 'title', 'created_at']).catch('created_at'),
});
export type UnitsOfCompetencyTableFilters = z.infer<typeof unitsOfCompetencyTableFiltersSchema>;
